import React, { useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import './ThreatsProgressBar.scss';
import { useNavigate } from 'react-router-dom';

type Props = {
  value?: number; // Make value optional
  count?: number; // Make count optional
  maxvalue: number;
  label: string;
  onClick?: () => void; // Add onClick prop
  active?: boolean;
  setActive?: any;
  color?: string;
  checkbox?: boolean;
  darkmode?: boolean; // Add darkmode prop
};

export const ThreatsProgressBar: React.FC<Props> = (props: Props) => {
  const [selectedLabel, setSelectedLabel] = useState<string | null>(null);
  const navigate = useNavigate();
  const handleClick = () => {
    if (props.onClick && props.active === false) {
      props.onClick();
    }

    if (selectedLabel !== props.label && props.active === false) {
      // Revert color of previously clicked label
      if (selectedLabel) {
        const prevLabelElement = document.querySelector(`.ProgressBarTitle[data-label='${selectedLabel}']`);
        if (prevLabelElement) {
          prevLabelElement.classList.remove('clicked');
        }
        const prevCountElement = document.querySelector(`.ProgressBarQty[data-label='${selectedLabel}']`);
        if (prevCountElement) {
          prevCountElement.classList.remove('clicked');
        }
      }
      setSelectedLabel(props.label);
      // props.setActive(true);
    } else if (selectedLabel !== null) {
      if (props.onClick) {
        props.onClick();
        setSelectedLabel(null); // Unselect if the same label is clicked again
        // props.setActive(false);
      }
    }
  };

  let checkboxVisibility

  if (props.checkbox === true) {
    checkboxVisibility = true
  }

  return (
    <div className="bar" onClick={handleClick}>
        {checkboxVisibility && (
          <input
            className="checkbox"
            type="checkbox"
            checked={props.active} // Controlled by props
            onChange={handleClick} // Fix: use onChange instead of onClick
          />
        )}
      <div className="flex justify-between gap-10 align-items-center">
        <label
          className={`ProgressBarTitle ${selectedLabel === props.label ? 'clicked' : ''}`}
          htmlFor=""
          data-label={props.label}
          // style={{ color: props.darkmode ?'#ffff' : '#000' }} // Update color based on selection
        >
          {props.label}
        </label>
        <label
          className={`ProgressBarQty ${selectedLabel === props.label ? 'clicked' : ''}`}
          htmlFor=""
          data-label={props.label}
// style={{ color: props.darkmode ?'#ffff' : '#000' }} // Update color based on selection
        >
          {(props.count != null ? props.count : '0').toLocaleString()}
        </label>
      </div>
      <ProgressBar style={{ height: '8px' }} min={0} max={props.maxvalue} now={props.value || 0} />
    </div>
  );
};
